import { ChartBarIcon, CogIcon } from '@heroicons/react/outline'
import { OodleLink } from './OodleLink'
import { GAME_TITLE } from '../../constants/countSpecific'

type Props = {
  setIsInfoModalOpen: (value: boolean) => void
  setIsStatsModalOpen: (value: boolean) => void
  setIsSettingsModalOpen: (value: boolean) => void
}

export const Navbar = ({
  setIsInfoModalOpen,
  setIsStatsModalOpen,
  setIsSettingsModalOpen,
}: Props) => {
  const currentUrl = window.location.href;
  const isBeta = currentUrl.includes("beta") || currentUrl.includes("localhost");
  const gameTitle = GAME_TITLE + (isBeta ? " -- BETA" : "");

  return (
    <div className="navbar">
      <div className="navbar-content px-5 align-middle">
        <div className="flex flex-1 justify-start">
          <div
            className="ml-0 mr-4 w-5 h-5 font-bold rounded-full text-black dark:text-white bg-white dark:bg-black flex border-black dark:border-white border-2 items-center justify-center font-mono"
            onClick={() => setIsInfoModalOpen(true)}
          >
            i
          </div>
          <OodleLink wordCount={2} gameName="twodle" />
          <OodleLink wordCount={3} gameName="threedle" />
          <OodleLink wordCount={4} gameName="fourdle" />
        </div>
        <p className="text-center flex-1 justify-center text-xl ml-2.5 font-bold dark:text-white">
          {gameTitle}
        </p>
        <div className="flex-1 justify-end right-icons">
          <ChartBarIcon
            className="h-6 w-6 mr-3 cursor-pointer dark:stroke-white"
            onClick={() => setIsStatsModalOpen(true)}
          />
          <CogIcon
            className="h-6 w-6 cursor-pointer dark:stroke-white"
            onClick={() => setIsSettingsModalOpen(true)}
          />
        </div>
      </div>
      <hr></hr>
    </div>
  )
}
